export default __webpack_public_path__ + "static/media/insta.1568f286.svg";